// @core/api/endpoints/chat/subscribe_to_mention_tag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MentionTagSubscriptionResponse,
  SubscribeToMentionTagRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Subscribe to a mention tag
 * Subscribes the current user to a mention tag. The user will receive notifications when the tag is mentioned in a message.
 */
export async function SubscribeToMentionTag(
  conversation_id: string,
  mention_tag_id: string,
  data: SubscribeToMentionTagRequest,
  options?: RequestOptions
): Promise<MentionTagSubscriptionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/mention-tags/:mention_tag_id/subscribe`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  requestPath = requestPath.replace(':mention_tag_id', encodeURIComponent(mention_tag_id));
  const requestOptions = options;
  return client.post<MentionTagSubscriptionResponse>(requestPath, data, requestOptions);
}
